import { Raycaster } from 'three';
import { Power2 } from 'gsap/EasePack';
import { TimelineMax } from 'gsap/TweenMax';

class Raycasting extends Raycaster {
  constructor() {
    super();
    this.intersected = null;
  }

  calculateIntersections(mouse, camera, objects) {
    const normalizedMouse = {
      x: (mouse.mouse.x / window.innerWidth) * 2 - 1,
      y: -(mouse.mouse.y / window.innerHeight) * 2 + 1,
    };
    this.setFromCamera(normalizedMouse, camera);
    const intersectMeshes = [];
    objects.forEach((group) => {
      group.children.forEach(child => intersectMeshes.push(child));
    });
    const intersections = this.intersectObjects(intersectMeshes);
    if (intersections.length === 0) this.intersected = null;
    intersections.forEach((intersection) => {
      const { parent } = intersection.object;
      if (this.intersected === null || this.intersected.uuid !== parent.uuid) {
        this.intersected = parent;
        const tl = new TimelineMax();
        tl.to(parent.userData.inertia, 0.4, {
          x: mouse.velocity.x * mouse.direction.x * -0.005,
          y: mouse.velocity.y * mouse.direction.y * 0.005,
          ease: Power2.easeOut,
        }).to(parent.userData.inertia, 4, {
          x: 0,
          y: 0,
          ease: Power2.easeOut,
        });
      }
    });
  }
}

export default new Raycasting();
